import React from "react";
import { Container, Row, Col } from "react-bootstrap";

function TrustBar() {
  const items = [
    {
      icon: "🚚",
      title: "Free UK Delivery",
      text: "On orders over £50",
    },
    {
      icon: "↩️",
      title: "30 Day Returns",
      text: "Easy & hassle-free",
    },
    {
      icon: "🔒",
      title: "Secure Checkout",
      text: "Stripe Protected",
    },
    {
      icon: "⭐",
      title: "Rated 4.9/5",
      text: "Thousands of happy customers",
    },
  ];

  return (
    <Container fluid className="py-4">
      <div
        style={{
          background: "#ffffff",
          borderRadius: "24px",
          padding: "30px",
          boxShadow: "0 10px 35px rgba(0,0,0,.08)",
        }}
      >
        <Row className="text-center g-4">
          {items.map((item, index) => (
            <Col md={3} sm={6} key={index}>
              <div
                style={{
                  fontSize: "40px",
                  marginBottom: "10px",
                }}
              >
                {item.icon}
              </div>

              <h5
                style={{
                  fontWeight: 700,
                  marginBottom: "6px",
                }}
              >
                {item.title}
              </h5>

              <div
                style={{
                  color: "#6b7280",
                  fontSize: "14px",
                }}
              >
                {item.text}
              </div>
            </Col>
          ))}
        </Row>
      </div>
    </Container>
  );
}

export default TrustBar;